var render = function render(_c,_vm){return _c('div',{staticClass:"trail-loader"})
}
var staticRenderFns = []

export { render, staticRenderFns }